import { VisualState } from '@wix/seating-common-components';
export const getVisualState = ({ selected, occupied }) => {
    if (selected) {
        return VisualState.SELECTED;
    }
    if (occupied) {
        return VisualState.OCCUPIED;
    }
    return VisualState.NORMAL;
};
//# sourceMappingURL=utils.js.map